import type { ThemeConfig } from "@/types";

const themeConfig: ThemeConfig = {
    app: {
        name: "Dashcode React",
    },
    // layout
    layout: {
        isRTL: false,
        darkMode: false,
        semiDarkMode: false,
        skin: "default",
        contentWidth: "full",
        type: "vertical",
        navBarType: "sticky",
        footerType: "static",
        isMonochrome: false,
        menu: {
            isCollapsed: false,
            isHidden: false,
        },
        mobileMenu: false,
        customizer: false,
    },
};

export default themeConfig;
